import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import StaffInductionForm from './StaffInductionForm';

// Wrapper that loads an existing induction and passes it to the form in edit mode
export default function StaffInductionEdit() {
  const { id }   = useParams();
  const navigate = useNavigate();

  const [existing, setExisting] = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    api.get(`/staff-inductions/${id}`)
      .then(({ data }) => setExisting(data.induction))
      .catch(err => setError(err.response?.data?.message || 'Failed to load induction'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Inter,sans-serif', color:'var(--muted)' }}>
      <i className="ti ti-loader" style={{ fontSize:'24px', color:'var(--blue)' }} aria-hidden="true"/>
    </div>
  );

  if (error) return (
    <div style={{ minHeight:'100vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', fontFamily:'Inter,sans-serif', gap:'16px' }}>
      <div style={{ color:'var(--red)' }}>{error}</div>
      <button onClick={()=>navigate(-1)} style={{ background:'var(--surface)', border:'1px solid var(--border-md)', borderRadius:'8px', padding:'8px 18px', cursor:'pointer', fontFamily:'inherit' }}>← Back</button>
    </div>
  );

  return <StaffInductionForm existingData={existing} editMode inductionId={id} />;
}
